"use strict";
/*
 * Copyright Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.reviewUuidKeyedCollectionKeysByObjectType = exports.interviewListStatusFilterValues = exports.interviewReviewStatusFilterValues = exports.reviewDecisionEffectiveStatuses = void 0;
/**
 * Aggregated review statuses an object can resolve to, ordered for display in
 * the admin interview list dropdown.
 */
exports.reviewDecisionEffectiveStatuses = [
    'notReviewed',
    'approved',
    'rejected',
    'conflict',
    'forceApproved'
];
/**
 * Review status values the admin interview list can be filtered on. Besides the
 * effective statuses, it accepts `all` (no filtering) and `notRejected`, which hides the
 * interviews whose status is `rejected`. An interview a reviewer rejected and another approved
 * is a `conflict`, not a rejection, and stays in the list: the disagreement is unsettled.
 */
exports.interviewReviewStatusFilterValues = ['all', ...exports.reviewDecisionEffectiveStatuses, 'notRejected'];
/**
 * Values offered by the status dropdown of the admin interview list: the review statuses, plus
 * two values that are not statuses. `questionable` is a flag of its own column on the interview,
 * and `modifiedSinceReview` finds the interviews the participant answered again after they were
 * reviewed, whose review therefore no longer describes their answers.
 */
exports.interviewListStatusFilterValues = [
    ...exports.interviewReviewStatusFilterValues,
    'questionable',
    'modifiedSinceReview'
];
exports.reviewUuidKeyedCollectionKeysByObjectType = {
    person: 'persons',
    journey: 'journeys',
    visitedPlace: 'visitedPlaces',
    trip: 'trips',
    segment: 'segments',
    organization: 'organizations',
    vehicle: 'vehicles',
    tripChain: 'tripChains',
    junction: 'junctions',
    workPlace: 'workPlaces',
    schoolPlace: 'schoolPlaces'
};
//# sourceMappingURL=types.js.map